<template>
    <div style="text-align: center;">
        <h1>(404) Page Not Found</h1>
        <br/>
    </div>
</template>

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

<script>
export default {
    metaInfo () {
        return {
            title: "App | Page Not Found"
        };
    },
};
</script>